// extracted by mini-css-extract-plugin
export default {"addAnnouncement":"Announcement_addAnnouncement__9fNNP","addButtuon":"Announcement_addButtuon__0FJ5b"};